import { render } from "./AccountInforCard.vue?vue&type=template&id=2670e7d0&scoped=true"
import script from "./AccountInforCard.vue?vue&type=script&lang=js"
export * from "./AccountInforCard.vue?vue&type=script&lang=js"

import "./AccountInforCard.vue?vue&type=style&index=0&id=2670e7d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2670e7d0"

export default script